export enum EquipmentType {
  CHASSIS = 'CHASSIS',
  CONTAINER = 'CONTAINER',
  GENSET = 'GENSET'
}

export enum DamageType {
  BENT = 'BENT',
  BROKEN = 'BROKEN',
  BURNED_OUT = 'BURNED OUT',
  CORRODED_OR_ROTTED = 'CORRODED/ROTTED',
  CRACKED = 'CRACKED',
  CUT = 'CUT',
  FROZEN_OR_SEIZED = 'FROZEN/SEIZED',
  IMPROPER = 'IMPROPER',
  LEAKING = 'LEAKING',
  LOOSE = 'LOOSE',
  MISSING = 'MISSING',
  SATURATED = 'SATURATED',
  SEPARATED = 'SEPARATED',
  SHORT = 'SHORT',
  WORN = 'WORN'
}

export type DamageOption = {
  id?: number;
  equipmentType: EquipmentType;
  subdivision1?: string;
  subdivision2?: string;
  damageName: string;
};
